<!-- 巡检维保统计 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <div class="base-box">
        <div class="base-item">
          <!-- <div class="base-text">
            <div class="title">累计巡检公里</div>
          </div> -->
          <div class="base-img">
            <div class="title">{{ $t('累计巡检公里') }}</div>
            <div class="num"><i>{{kilometer}}</i></div>
            <img src="@/assets/xj1.png" alt="" />
          </div>
        </div>
        <div class="base-item">
          <!-- <div class="base-text">
            <div class="title">累计保养次数</div>
          </div> -->
          <div class="base-img">
            <div class="title">{{ $t('累计保养次数') }}</div>
            <div class="num"><i>{{number}}</i></div>
            <img src="@/assets/xj2.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('巡检维保统计'),
        url: {
          LargeScreenSumByTime:"/jeecg-engineering/inspection/inspectionTask/LargeScreenSumByTime"
        },
        kilometer: 0,
        number: 0
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
      },
      getData(){
        postAction(this.url.LargeScreenSumByTime,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.kilometer = data.inspectionKmSum;
            this.number = data.inspectionMaintenanceNum;
          }
        })
      }
    },
  }
</script>
<style lang="less" scoped>
  .base-box {
    display: flex;
    height: 100%;

    .base-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 50%;
      height: 100%;

      // .title {
      //   padding: 5px 10px;
      //   background: url('~@/assets/images/top-header.png') #071737 no-repeat 100% 100%;
      //   font-size: 20px;
      //   line-height: 40px;
      //   background-color: transparent;
      // }

      .base-img {
        margin-top: 10px;
        width: 140px;
        height: 90%;
        position: relative;
        
        .title{
          width: 100%;
          padding: 5px 10px;
          font-size: 20px;
          line-height: 40px;
          position: absolute;
          top: 10%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        
        .num {
          font-family: fantasy;
          font-size: 30px;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      .base-text {
        color: #fff;
        font-size: 15px;
      }
    }
  }
</style>